import consola from 'consola'
/**
 * Плагин для отладки инициализации Capacitor
 */
export default defineNuxtPlugin(async () => {
  if (!process.client) return

  consola.log('🔧 Capacitor Debug Plugin: Starting...')

  // Ждем загрузки Capacitor
  let capacitorLoaded = false
  let attempts = 0
  const maxAttempts = 50

  const waitForCapacitor = (): Promise<void> => {
    return new Promise((resolve) => {
      const checkCapacitor = () => {
        attempts++
        
        if (window.Capacitor) {
          capacitorLoaded = true
          consola.log('✅ Capacitor loaded successfully!')
          consola.log('📱 Platform:', window.Capacitor.getPlatform())
          consola.log('📱 Native platform:', window.Capacitor.isNativePlatform())
          resolve()
        } else if (attempts < maxAttempts) {
          consola.log(`⏳ Waiting for Capacitor... (${attempts}/${maxAttempts})`)
          setTimeout(checkCapacitor, 100)
        } else {
          consola.error('❌ Capacitor failed to load after', maxAttempts * 100, 'ms')
          resolve()
        }
      }
      
      checkCapacitor()
    })
  }

  // Запускаем проверку
  await waitForCapacitor()

  if (capacitorLoaded) {
    consola.log('🎉 Capacitor initialization complete!')
  } else {
    consola.error('💥 Capacitor initialization failed!')
  }
})

// Расширяем Window interface для TypeScript
declare global {
  interface Window {
    Capacitor?: any
  }
}
